import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router'

import * as ROUTES from 'config/routes'
// import DetectableEdit from './detectable-edit'
import DetectableList from './detectable-list'
import DetectableAdd from './detectable-add'
import { PageContent } from 'components'
import { PageContainer } from 'smart-components'
import { userIsAuthenticatedRedir } from 'hocs/auth'

const Detectable = () => (
    <PageContainer>
        <PageContent>
            <PageContent.Main>
                <Switch>
                    <Route
                        exact
                        path={ROUTES.DETECTABLE}
                        component={DetectableList}
                    />
                    {/* <Route
                        exact
                        path={ROUTES.DETECTABLE_EDIT}
                        component={DetectableEdit}
                    /> */}
                    <Route
                        exact
                        path={ROUTES.DETECTABLE_ADD}
                        component={DetectableAdd}
                    />
                </Switch>
            </PageContent.Main>
        </PageContent>
    </PageContainer>
)

export default userIsAuthenticatedRedir(Detectable)



// WEBPACK FOOTER //
// ./src/pages/detectable/index.js